import SnackbarUtils from './SnackbarUtilsConfigurator';

export const openBillingPortal = (email?: string) => {
  if (process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL) {
    const encodedEmail = encodeURIComponent(email || '');
    const url = `${process.env.REACT_APP_STRIPE_CUSTOMER_PORTAL_URL}?prefilled_email=${encodedEmail}`;
    window.open(url, '_blank');
  } else {
    SnackbarUtils.error(
      'No billing portal URL found. Please contact the developer.'
    );
  }
};
